import { Store } from '../../../../helpers';
import { plotHeatmap, removeHeatmap } from '../redux/heatmap.map';
import {
  setMaxOffers,
  setMaxPrice,
  updateHeatmapData,
  updateHeatmapType,
} from '../redux/heatmap.reducer';

export const isHeatmapAvailable = () => {
  const { markers, displayCharts } = Store.getState().dashboardState;
  const isPrimary = displayCharts === 'primaryMarketEcoMap';
  const isSecondary = displayCharts === 'secondaryMarket';
  return !!markers.length && (isPrimary || isSecondary);
};

export const createHeatmap = async (
  type: 'price' | 'offers',
  market: 'primaryMarket' | 'secondaryMarket',
  opacity: number
) => {
  await plotHeatmap(type, market, opacity);
};

export const cleanHeatmap = async () => {
  await removeHeatmap();
  Store.dispatch(updateHeatmapType(''));
};

export const getHeatmapDataFromBigNumber = (
  pins: Array<Record<string, string | number | number[]>>,
  bigNumbers: Record<string, string | number>,
  type: 'primaryMarket' | 'secondaryMarket'
) => {
  const offerQuantityHeatmapPayload = pins.map(
    ({ location_point, offer_quantity_weight }) => {
      const [lat, lng] = location_point as number[];
      return {
        location: new google.maps.LatLng(lat, lng),
        weight: type === 'secondaryMarket' ? 1 : offer_quantity_weight,
      };
    }
  );
  const sqrMeterPriceQuantityHeatmapPayload = pins.map(
    ({ location_point, sqr_meter_price_weight }) => {
      const [lat, lng] = location_point as number[];
      return {
        location: new google.maps.LatLng(lat, lng),
        weight: sqr_meter_price_weight,
      };
    }
  );

  const maxOffersSecondaryMarket = pins.length;
  const maxOffersPrimaryMarket = bigNumbers?.max_offer_qtd || 0;
  const maxOffers =
    type === 'primaryMarket'
      ? maxOffersPrimaryMarket
      : maxOffersSecondaryMarket;
  Store.dispatch(
    updateHeatmapData({
      type,
      data: {
        offers: offerQuantityHeatmapPayload,
        price: sqrMeterPriceQuantityHeatmapPayload,
      },
    })
  );
  Store.dispatch(
    setMaxPrice({
      market: type,
      maxPrice: bigNumbers?.max_square_mt_price || 0,
    })
  );
  Store.dispatch(
    setMaxOffers({
      market: type,
      maxOffers,
    })
  );
};
